export default "__VITE_ASSET__DI2kXwrz__"